/** Gerencia buscas recentes e a busca preditiva no painel lateral. */

const COOKIE_KEY = 'urbo_recent_searches';
const MAX_RECENT = 10;
const COOKIE_DAYS = 30;
const SEARCH_PARAMS = 'type=product&options%5Bprefix%5D=none';

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function getRecentSearches() {
  try {
    const raw = getCookie(COOKIE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveRecentSearches(searches) {
  setCookie(COOKIE_KEY, JSON.stringify(searches.slice(0, MAX_RECENT)), COOKIE_DAYS);
}

function addRecentSearch(term) {
  const clean = term.trim();
  if (!clean) return;

  let searches = getRecentSearches();
  searches = searches.filter(s => s.toLowerCase() !== clean.toLowerCase());
  searches.unshift(clean);
  saveRecentSearches(searches);
}

function renderRecentSearches(container, emptyState) {
  const searches = getRecentSearches();

  if (searches.length === 0) {
    container.innerHTML = '';
    emptyState.classList.remove('hidden');
    return;
  }

  emptyState.classList.add('hidden');
  container.innerHTML = searches.map(term => `
    <a
      href="/search?q=${encodeURIComponent(term)}&${SEARCH_PARAMS}"
      class="search-drawer-recent"
    >
      ${escapeHtml(term)}
    </a>
  `).join('');
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function formatMoney(priceValue) {
  // A Shopify retorna price como string decimal (ex: "140.00")
  const num = parseFloat(priceValue);
  if (isNaN(num)) return '';
  return num.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}

let abortController = null;

async function fetchPredictiveSearch(term) {
  if (abortController) abortController.abort();
  abortController = new AbortController();

  const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][prefix]=none&resources[options][fields]=title,product_type,variants.title`;

  try {
    const res = await fetch(url, { signal: abortController.signal });
    if (!res.ok) throw new Error('Erro na busca');
    const data = await res.json();
    return data.resources?.results?.products || [];
  } catch (err) {
    if (err.name === 'AbortError') return null;
    console.error('Predictive search error:', err);
    return [];
  }
}

function renderPredictiveResults(products, container, emptyState, viewAllLink, term) {
  if (!products || products.length === 0) {
    container.innerHTML = '';
    emptyState.hidden = false;
    if (viewAllLink) viewAllLink.hidden = true;
    return;
  }

  emptyState.hidden = true;
  if (viewAllLink) {
    viewAllLink.href = `/search?q=${encodeURIComponent(term)}&${SEARCH_PARAMS}`;
    viewAllLink.hidden = false;
  }

  container.innerHTML = products.map(product => {
    const image = product.image
      ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="72" height="90">`
      : '';

    const price = product.price !== undefined
      ? `<small>${formatMoney(product.price)}</small>`
      : '';

    return `
      <a
        href="${escapeHtml(product.url)}"
        class="search-drawer-product"
      >
        ${image}
        <span><strong>${escapeHtml(product.title)}</strong>${price}</span>
      </a>
    `;
  }).join('');
}

function debounce(fn, ms) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

function initSearchDrawer() {
  const drawer = document.getElementById('header-search-drawer');
  if (!drawer) return;

  const input = drawer.querySelector('[data-search-input]');
  const form = drawer.querySelector('form');
  const idle = drawer.querySelector('[data-search-idle]');
  const predictive = drawer.querySelector('[data-predictive-panel]');
  const results = drawer.querySelector('[data-predictive-results]');
  const empty = drawer.querySelector('[data-predictive-empty]');
  const viewAll = drawer.querySelector('[data-view-all-link]');
  const openers = document.querySelectorAll('[data-search-open]');
  let activeOpener = null;
  let closeTimer = null;
  let previousOverflow = '';

  function showIdle() {
    idle.hidden = false;
    predictive.hidden = true;
    renderRecentSearches(
      drawer.querySelector('[data-recent-searches-container]'),
      drawer.querySelector('[data-empty-state]')
    );
  }

  const runPredictive = debounce(async term => {
    if (!term || input.value.trim() !== term) return;
    results.innerHTML = '<p class="search-drawer-empty">Buscando...</p>';
    empty.hidden = true;
    viewAll.hidden = true;
    const products = await fetchPredictiveSearch(term);
    if (products === null || input.value.trim() !== term) return;
    renderPredictiveResults(products, results, empty, viewAll, term);
  }, 250);

  function openDrawer(opener) {
    if (closeTimer) clearTimeout(closeTimer);
    activeOpener = opener;
    previousOverflow = document.body.style.overflow;
    drawer.style.display = 'block';
    drawer.setAttribute('aria-hidden', 'false');
    openers.forEach(button => button.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    if (!input.value.trim()) showIdle();
    // A leitura de layout inicia a transição antes do foco, no mesmo gesto de toque.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    input.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (drawer.getAttribute('aria-hidden') === 'true') return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = previousOverflow;
    if (drawer.contains(document.activeElement) && activeOpener) activeOpener.focus();
    if (abortController) abortController.abort();
    input.value = '';
    showIdle();
    closeTimer = setTimeout(() => { drawer.style.display = 'none'; }, 300);
  }

  openers.forEach(button => button.addEventListener('click', () => openDrawer(button)));
  drawer.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', event => {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab') {
      const focusable = [...drawer.querySelectorAll('a[href], button, input')]
        .filter(element => element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  input.addEventListener('input', () => {
    const term = input.value.trim();
    if (!term) {
      if (abortController) abortController.abort();
      showIdle();
      return;
    }
    idle.hidden = true;
    predictive.hidden = false;
    results.innerHTML = '<p class="search-drawer-empty">Buscando...</p>';
    empty.hidden = true;
    viewAll.hidden = true;
    runPredictive(term);
  });

  form.addEventListener('submit', () => {
    if (input.value.trim()) addRecentSearch(input.value);
  });
}

function initSearchForm(form) {
  // O painel já registra as buscas no seu próprio formulário.
  if (form.closest('#header-search-drawer')) return;

  form.addEventListener('submit', (e) => {
    const input = form.querySelector('input[name="q"]');
    if (input) {
      const term = input.value.trim();
      if (term) {
        addRecentSearch(term);
      }
    }
  });
}

// Inicializar o painel e os demais formulários de busca na página.
document.addEventListener('DOMContentLoaded', () => {
  initSearchDrawer();

  // Captura formulários fora do painel (ex: página de busca).
  document.querySelectorAll('form[action*="/search"]').forEach(initSearchForm);
});
